import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { toast } from "sonner";

export default function Register() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.success) {
      navigate("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-background grain-overlay flex items-center justify-start px-6 md:px-24 relative" data-testid="register-page">
      <LanguageSwitcher className="absolute top-6 right-6" />
      <div className="w-full max-w-sm">
        <p className="font-mono-tag text-xs text-primary mb-3">{t("app.tagline")}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight mb-8">
          {t("auth.registerTitle1")}<br />{t("auth.registerTitle2")}
        </h1>
        <form onSubmit={handleSubmit} className="space-y-5 border border-border p-6 bg-card brutal-shadow-sm">
          <div className="space-y-2">
            <Label htmlFor="name">{t("auth.name")}</Label>
            <Input id="name" data-testid="register-name-input" required value={name} onChange={(e) => setName(e.target.value)} placeholder={t("auth.namePlaceholder")} className="rounded-none" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" data-testid="register-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="rounded-none" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">{t("auth.password")}</Label>
            <Input id="password" data-testid="register-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("auth.passwordHint")} className="rounded-none" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-button" className="w-full rounded-none bg-primary hover:bg-primary/90 hover:-translate-y-[2px] transition-transform font-semibold">
            {loading ? t("auth.registeringUp") : t("auth.registerButton")}
          </Button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">
          {t("auth.haveAccount")}{" "}
          <Link to="/login" data-testid="go-to-login-link" className="text-primary font-semibold underline-offset-4 hover:underline">
            {t("auth.goLogin")}
          </Link>
        </p>
      </div>
    </div>
  );
}
